/* eslint-disable react/require-default-props */
import { forwardRef, useMemo } from 'react'
import { Col, Row } from 'antd'
import PropTypes from 'prop-types'

import { ImageType } from '../types'
import withScroll from 'common/utils/withScroll'
import { BynderPicture, Container, CTALink, GradientBlock, Typography } from 'common/widgets'
import classNames from './styles.module.scss'


const propTypes = {
  data: PropTypes.shape({
    image: ImageType,
    heading: PropTypes.string,
    text: PropTypes.string,
    buttons: PropTypes.arrayOf(PropTypes.shape({
      cta_link_caption: PropTypes.string,
      cta_link: PropTypes.string,
      cta_link_type: PropTypes.string,
    })),
  }),
}

const HeroImageAnimated = forwardRef(({
  data = {},
}, ref) => {
  const ctas = useMemo(() => data.buttons.map(({ cta_link_caption: ctaLinkCaption, cta_link: ctaLink, cta_link_type: ctaLinkType }) => (
    <div key={ctaLinkCaption} className={classNames.ctaContainer}>
      <CTALink
        cta={ctaLinkCaption}
        ctaURL={ctaLink}
        className={classNames.cta}
        type={ctaLinkType}
      />
    </div>
  )), [data.buttons])

  return (
    <div className={classNames.wrapper}>
      <BynderPicture
        image={data.image}
        priority
        desktopImage={{
          maxWidth: 1920,
          maxHeight: 500,
          sizes: '100vw',
        }}
        mobileImage={{
          maxWidth: 800,
          maxHeight: 500,
          sizes: '100vw',
        }}
      />
      <GradientBlock />
      <Container size="xl">
        <Row className={classNames.container} ref={ref}>
          <Col span={24} lg={12} xl={10}>
            <Typography variant="h2" color="white">{data.heading}</Typography>
            <Typography color="white" className={classNames.text}>{data.text}</Typography>
            <div className={classNames.ctas}>
              {ctas}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
})

HeroImageAnimated.propTypes = propTypes

export default withScroll(HeroImageAnimated, classNames.active)
